<template>
    <DashboardHeader />
    <div class="section overflow-hidden position-relative" id="wrapper">
        <DashboardSidebar 
            @sidebar-toggle="handleSidebarToggle"
            :is-mobile="isMobile"
        />
        <div class="main-content" :style="contentStyle">
            <router-view />
        </div>
    </div>
    <DashboardFooter />
</template>

<script>
import DashboardHeader from "@/components/Dashboard/DashboardHeader.vue";
import DashboardFooter from "./../DashboardFooter.vue";
import DashboardSidebar from "./DashboardSidebar.vue";

export default {
    name: "OrganizationDashboardLayout",
    components: {
        DashboardHeader,
        DashboardFooter,
        DashboardSidebar,
    },
    data() {
        return {
            sidebarExpanded: false,
            isMobile: false
        };
    },
    computed: {
        contentStyle() {
            // Mobile: fixed margin, Desktop: responsive to sidebar
            if (this.isMobile) {
                return {
                    marginLeft: '60px',
                    padding: '15px'
                };
            }
            return {
                marginLeft: this.sidebarExpanded ? '220px' : '100px'
            };
        }
    },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        handleSidebarToggle(isExpanded) {
            this.sidebarExpanded = isExpanded;
        },
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        }
    }
};
</script>

<style scoped>
.main-content {
    transition: margin-left 0.3s ease;
    min-height: calc(100vh - 80px);
}

/* Mobile responsive */
@media (max-width: 768px) {
    .main-content {
        margin-left: 60px !important;
        padding: 15px !important;
    }
}

@media (max-width: 576px) {
    .main-content {
        margin-left: 50px !important;
        padding: 10px !important;
    }
}
</style>